const attendees = {
	title: "Deltagere",
	new_attendee: "Nye deltagere",
	edit_attendee: "Rediger deltager",
	view_attendee: "Vis deltager",
	list_title: "Deltagerliste",
	list_subtitle: "Håndter deltagere",
	create_title: "Opprett ny deltager",
	update_title: "Oppdater deltager",
	address_title: "Adresse",
	details_title: "Deltager informasjon",
	other_title: "Annen informasjon",
	id: "ID",
	course_id: "Kurs",
	participant_id: "Deltager",
	driving_test_id: "Oppkjøring",
	enrolled_organisation_id: "Organisasjon",
	enrolled_date: "Påmelding",
	confirmation_sent: "Bekreftelse sendt?",
	certificate_emailed: "Sertifikat sendt?",
	course_attended: "Deltat på kurs",
	course_photo_taken: "Bilde er tatt",
	course_practice_completed: "Praktisk del fullført",
	course_completed: "Kurs fullført",
	comment: "Kommentar",
	created_by: "Opprettet av",
	student_name: "Deltager navn",
	image: "Bilde tatt",
	req_course_completed: "Obl.kurs godkjent",
	documents_provided: "Dokumenter levert",
	met_up_days: "Oppmøte (dag)",
	theory_test: "Teoriprøve",
	certificate: "Diplom",
	filename: "Filnavn",
	mime: "Type",
	path: "Bane",
	size: "Størrelse",
	accomplishment: "Progresjon",
	accomplishment_for: "Progresjon for {course_name}",
	expertise_checked_confirm: "Kompetansebevis for valgte personer vil bli generert eller skjult. Vil du fortsette?",
	total_percentage_of_student: "% gjennomført",
	total_percentage: "Totalt %",
	release_certificate: "Opprett komp.bevis",
	course_certificate: "Kursbevis",
	certificate_chk: "Komp. bevis",
	certificate_created_on_by: "Bevis opprettet den {date} av {name}",
	mandatory_module_required: "Ikke alle obligatoriske moduler er merket fullført for denne eleven.",
	birthday_required: "Fødselsdato er obligatorisk. Vennligst set det for elev før kursbevis/sertifikat kan utstedes.",
	accomplishment_mandatory_addedupdated_confirm: "Minst en av elevene har fullført kurset. Hvis du legger til dette obligatoriske valget vil Fullført status bli fjernet. Vil du fortsette?",
	accomplishment_long_course_update_success: "Kompetanse er oppdatert og vil være tilgjengelig for elever.",
	delete_selected_confirmation: "Valgte deltagere blir slettet. Vil du fortsette?",
	set_completion_date: "Sett dato for fullført kurs",
};
export default attendees;